var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRightAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180, 11, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5638 8.66674H4.75051L9.59051 2.85341C10.0618 2.28639 9.98419 1.44469 9.41718 0.973406C8.85016 0.502123 8.00846 0.579727 7.53718 1.14674V1.14674L0.870509 9.14674C0.825657 9.21037 0.785549 9.27722 0.750509 9.34674C0.750509 9.41341 0.750509 9.45341 0.657176 9.52007H0.657176C0.596741 9.67295 0.565098 9.83569 0.563843 10.0001L0.563843 10.0001C0.565098 10.1645 0.596741 10.3272 0.657177 10.4801C0.657177 10.5467 0.657177 10.5867 0.75051 10.6534C0.785549 10.7229 0.825658 10.7898 0.87051 10.8534L7.53718 18.8534C7.79099 19.1581 8.16727 19.3341 8.56384 19.3334C8.87538 19.334 9.17729 19.2255 9.41718 19.0267C9.98407 18.5568 10.0626 17.7162 9.59264 17.1493C9.59193 17.1484 9.59122 17.1476 9.59051 17.1467L4.75051 11.3334H20.5638C21.3002 11.3334 21.8972 10.7364 21.8972 10.0001C21.8972 9.26369 21.3002 8.66674 20.5638 8.66674V8.66674Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRightAlt);
export default __webpack_public_path__ + "static/media/menu-right-alt.6ec8bd1eb47b412aa2de01f300a1a491.svg";
export { ForwardRef as ReactComponent };